import { render, staticRenderFns } from "./NewProject.vue?vue&type=template&id=47c256f4&"
import script from "./NewProject.vue?vue&type=script&lang=js&"
export * from "./NewProject.vue?vue&type=script&lang=js&"
import style0 from "./NewProject.vue?vue&type=style&index=0&id=47c256f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports